export default __webpack_public_path__ + "static/media/Grouprishico.eabb531c.svg";